import type { ReferenceDataItem, DeploymentActionPackageResource, ProjectResource, GitRefResource } from "@octopusdeploy/octopus-server-client";
import { getGitRefDescription, displayName } from "@octopusdeploy/octopus-server-client";
import type * as React from "react";
import { ChipIcon, DeploymentActionPackageChip, MissingChip } from "~/components/Chips";
import type { SelectItem } from "~/components/VirtualListWithKeyboard/SelectItem";
import type { FormFieldProps } from "~/components/form";
import Lookup from "../Lookup";
import { DeprecatedMultiSelect } from "./MultiSelect";
interface DeploymentActionPackageMultiSelectProps extends FormFieldProps<string[]> {
    items: DeploymentActionPackageReferenceDataItem[];
    customLabel?: string;
    openOnFocus?: boolean;
    label?: string | JSX.Element;
    error?: string;
    hideFloatingLabel?: boolean;
    project: ProjectResource;
    gitRef?: GitRefResource;
}
export class DeploymentActionPackageReferenceDataItem implements ReferenceDataItem {
    Id: string;
    Name: string;
    ActionPackage: DeploymentActionPackageResource;
    IsInCurrentProcess: boolean;
    constructor(actionPackage: DeploymentActionPackageResource, id: string, isInCurrentProcess: boolean = true) {
        this.Id = id;
        this.Name = displayName(actionPackage);
        this.ActionPackage = actionPackage;
        this.IsInCurrentProcess = isInCurrentProcess;
    }
}
const DeploymentActionPackageTypedMultiSelect = DeprecatedMultiSelect<DeploymentActionPackageReferenceDataItem>();
const DeploymentActionPackageMultiSelect: React.FC<DeploymentActionPackageMultiSelectProps> = (props) => {
    const chipRenderer = (r: DeploymentActionPackageReferenceDataItem | SelectItem, onRequestDelete: () => void) => {
        const missingStepDescription = props.project.IsVersionControlled
            ? `Step '${r.Id}' does not exist in the deployment process on the '${props.gitRef?.Name}' ${getGitRefDescription(props.gitRef?.CanonicalName)}.`
            : `Step '${r.Id}' does not exist in the deployment process.`;
        return (<Lookup lookupCollection={props.items} lookupId={r.Id} getIdFromElement={(element: DeploymentActionPackageReferenceDataItem) => element.Id} render={(item: DeploymentActionPackageReferenceDataItem) => {
                if (item.IsInCurrentProcess) {
                    return <DeploymentActionPackageChip deleteButtonAccessibleName={`Delete ${item.Name}`} onRequestDelete={onRequestDelete} actionPackage={item.ActionPackage}/>;
                }
                return (<MissingChip lookupId={r.Id} type={ChipIcon.StepAction} text={displayName(item.ActionPackage)} description={missingStepDescription} deleteButtonAccessibleName={"Delete Missing Resource"} onRequestDelete={onRequestDelete}/>);
            }} renderFallback={<MissingChip lookupId={r.Id} type={ChipIcon.StepAction} deleteButtonAccessibleName={"Delete Missing Resource"} onRequestDelete={onRequestDelete}/>}/>);
    };
    return <DeploymentActionPackageTypedMultiSelect fieldName="package steps" renderChip={chipRenderer} {...props}/>;
};
DeploymentActionPackageMultiSelect.displayName = "DeploymentActionPackageMultiSelect"
export default DeploymentActionPackageMultiSelect;
